module.exports = __webpack_public_path__ + "static/media/nu.4d01f4d6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nu.svg
// module id = 915
// module chunks = 0